// Case Summary Component
// Displays automated case summary with translations

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Scale, Globe } from 'lucide-react';

const CaseSummary = ({ intake }) => {
  return (
    <Card className="border-slate-200 bg-gradient-to-br from-slate-50 to-white" data-testid="case-summary-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <Scale className="w-5 h-5 text-teal-500" />
          Case Summary
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* UPL Disclaimer */}
        <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
          <p className="text-xs text-amber-800">
            <strong>DISCLAIMER:</strong> This summary is for attorney review purposes only and does not constitute legal advice or case evaluation. 
            No attorney-client relationship is formed until a retainer agreement is signed. All case determinations must be made by a licensed attorney.
          </p>
        </div>
        
        {/* English Summary */}
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wide mb-2">English</p>
          <p className="text-slate-700 leading-relaxed">{intake.case_summary}</p>
        </div>
        
        {/* Translated Summary for non-English clients */}
        {intake.case_summary_client_language && intake.detected_language !== 'en' && (
          <div className="mt-4 p-4 bg-purple-50 rounded-lg border border-purple-200">
            <p className="text-xs font-semibold text-purple-800 uppercase tracking-wide mb-2 flex items-center gap-2">
              <Globe className="w-3 h-3" />
              {intake.detected_language_name} Translation
            </p>
            <p className="text-purple-900 leading-relaxed">{intake.case_summary_client_language}</p>
          </div>
        )}
        
        {intake.suggested_actions && (
          <div className="mt-4 p-4 bg-teal-50 rounded-lg border border-teal-200">
            <p className="text-xs font-semibold text-teal-800 uppercase tracking-wide mb-2">
              Suggested Next Steps
            </p>
            <p className="text-teal-700">{intake.suggested_actions}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CaseSummary;
